import * as Sentry from '@sentry/vue'
import { createSentryPiniaPlugin } from '@sentry/vue'

import { definePlugin } from '/@/app'

export default definePlugin(({ app, router, store }) => {
  const settings = useSettings()

  // Do not configure sentry in development mode.
  if (settings.mode === 'development') return

  Sentry.init({
    app,
    dsn: settings.sentryDsn,
    release: __APP_VERSION__,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
      Sentry.vueIntegration({
        tracingOptions: {
          trackComponents: true,
        },
      }),
      Sentry.browserProfilingIntegration(),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.brandefense\.io/,
      /^https:\/\/v2\.stage-bdef\.io/,
    ],
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    normalizeDepth: 10, // Oer however deep you want your state context to be.
    // Profiling
    profilesSampleRate: 1.0, // Profile 100% of the transactions. This value is relative to tracesSampleRate
  })
  store.use(createSentryPiniaPlugin())
})
